export const imageGenerationDrawerZIndex = 301;